// Sticky bar générique pour TOUTES les variantes landing-* MFS
// (landing-swarovski-*, landing-accessoire-*, landing-kit, et toute future variante)
// - Sélecteur sticky : [data-landing-sticky]
// - Sélecteur hero  : section[class*="landing-"] + [class$="__hero"]
document.addEventListener('DOMContentLoaded', () => {
  const stickyBars = document.querySelectorAll('[data-landing-sticky]');
  if (stickyBars.length === 0) return;

  stickyBars.forEach(stickyBar => {
    // Trouve le hero dans la même section parent (mfs landing-XXX)
    const sectionRoot = stickyBar.closest('section[class*="landing-"]');
    const heroSection = sectionRoot
      ? sectionRoot.querySelector('[class$="__hero"]')
      : document.querySelector('[class*="landing-"][class$="__hero"]');

    if (!heroSection) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px 100px 0px'
    });

    observer.observe(heroSection);
  });
});

// Galerie des landings produit : clic sur une miniature -> grande image + surbrillance
// (ajouté 24/09/2026 — les miniatures [data-landing-thumb] n'avaient aucun gestionnaire)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-landing-main-img]').forEach(mainImg => {
    const gallery = mainImg.closest('[class$="__gallery"]');
    if (!gallery) return;
    const thumbs = gallery.querySelectorAll('[data-landing-thumb]');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (!thumb.dataset.src) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
        thumbs.forEach(t => {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      });
    });
  });
});
